'use client'

import React, { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { getUser } from '../utils/userDetails'

const HomePage = () => {
  const router = useRouter();

  useEffect(() => {
    const user = getUser();
    if (user) {
      router.replace('/dashboard');
    } else {
      router.replace('/login');
    }
  }, [router]);

  return (
    <div className='text-5xl'>Redirecting...</div>
  )
}

export default HomePage;
